/**
 * Recently Viewed Products Module v2.4
 * 최근 본 상품 기록 및 표시
 * 
 * v2.4: 자체 쿠키 관리 로직 복원 (외부 의존성 제거)
 * v2.3: DOM 로딩 완료 후 상품 기록하도록 수정 (상품 등록 안되는 버그 해결)
 */
class recordRecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.cookieName = "wokiee_recently_viewed";
    // DOM이 완전히 로드된 후에 상품 기록 실행
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.recordRecentlyViewed());
    } else {
      this.recordRecentlyViewed();
    }
  }
  
  config(){
    return {
      howManyToStoreInMemory: Number(this.getAttribute('data-count'))+1,
      cookieDays: Number(this.getAttribute('data-cookie-days')) || 30,
      settings: this.getAttribute('data-settings')
    };
  }
  
  // 쿠키 설정
  setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  
  // 쿠키 읽기
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) {
        var arr = c.substring(nameEQ.length,c.length);
        return arr ? arr.split(' ').filter(item => item.length > 0) : [];
      }
    }
    return [];
  }
  
  recordRecentlyViewed(){ 
    var config = this.config(),
        recentlyViewed = this.getCookie(this.cookieName);
    
    // 상품 페이지인지 확인
    if (window.location.pathname.indexOf('/products/') !== -1) {
      var productHandleEl = document.querySelector('[data-product-handle]');
      if (!productHandleEl) {
        // data-product-handle 요소가 아직 없으면 재시도 (최대 5회)
        this._retryCount = (this._retryCount || 0) + 1;
        if (this._retryCount < 5) {
          setTimeout(() => this.recordRecentlyViewed(), 200);
        }
        return;
      }
      
      var productHandle = productHandleEl.getAttribute('data-product-handle');
      var position = recentlyViewed.indexOf(productHandle);
      
      if (position === -1) {
        recentlyViewed.unshift(productHandle);
        recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
      }
      else {
        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);              
      }
      this.setCookie(this.cookieName, recentlyViewed.join(' '), config.cookieDays);
    }
  }
}

class recentlyViewedProducts extends recordRecentlyViewedProducts {
  constructor() {
    super();
    
    var currentproducts = this.getCookie(this.cookieName);
    if(currentproducts.length <= 0){
        if(Shopify.designMode){
            this.getProducts("");
        }
        return;
    }

    // 현재 상품 페이지면 현재 상품 제외
    if (window.location.pathname.indexOf('/products/') !== -1) {
      var productHandleEl = document.querySelector('[data-product-handle]');
      if (productHandleEl) {
        var productHandle = productHandleEl.getAttribute('data-product-handle');
        var index = currentproducts.indexOf(productHandle);
        if (index !== -1) currentproducts.splice(index, 1);
      }
    }
    
    this.getProducts(currentproducts.join('||'));
  }
  
  getProducts(currentproducts){
    var _this = this;
    fetch(`${window.routes.collections_url}/all?view=ajax_recently_viewed&sort_by=${currentproducts}|split|${this.config().settings}`)
      .then((response) => response.text())
      .then((responseText) => {
        responseText == "" ? _this.classList.add("hide"):_this.classList.remove("hide");
        _this.querySelector('.recently-viewed-products-content').innerHTML = responseText;
      });
  }
}

customElements.define('recently-viewed-products', recentlyViewedProducts);
!document.querySelector('recently-viewed-products') && customElements.define('recently-viewed-products-record', recordRecentlyViewedProducts);